export function getPayFeeStateName(state, stateName = '') {
  const stateNames = {
    '2007001': '无收',
    '2008001': '未收',
    '2009001': '已收'
  }
  return stateNames[state] || stateName
}